import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'src/app/cross-platform-dialog/shared/DialogStructure';
import { DocumentService } from 'src/app/core/services/content/document.service';
import { I18nToastService } from 'src/app/core/services/i18n-toast.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-document-cancelation',
  templateUrl: './document-cancelation.component.html',
  styleUrls: ['./document-cancelation.component.scss']
})
export class DocumentCancelationComponent implements OnInit {

  public formGroup: FormGroup;
  public loading:boolean = false;
  

  constructor(
    private dialogRef: MatDialogRef<DocumentCancelationComponent>,
    private documentService: DocumentService,
    private toast: I18nToastService,
    public trans: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<{docId: string, type: string}>,
  ) { }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      reason: new FormControl(null, [Validators.required])
    });
  }

  public close(){
    this.dialogRef.close(true);
  }

  public action(): void{
    const { type } = this.data[0];
    const validated = new Subject<void>();

    let result = new Observable<any>();
    try{
      if(type === 'document'){
        result = this.documentService.cancel(this.data[0].docId, this.formGroup.value.reason)
      }else if(type === 'form'){
        result = this.documentService.cancelForm(this.data[0].docId, this.formGroup.value.reason);
      }

      result.subscribe(
        result => {
          if(result){
            if(!result.error){
              this.setErrors({}, this.formGroup);  
              this.toast.open(this.trans.instant('cancelation_confirmation'), 'Accept', 5000, true)
  
              this.dialogRef.close(true);
              validated.next();
              validated.complete();
            }else{
              this.setErrors({reason: [result.error]}, this.formGroup);  
            }
          }else{
            this.setErrors({reason: ["Algo ha fallado"]}, this.formGroup);  
          }
        }
      )
    }catch(e){
      console.log(e)
      this.setErrors({reason: ["Algo ha fallado"]}, this.formGroup);
    }
  }

  private setErrors(errors, control):void{

    Object.keys(errors).forEach(errPath =>
    {   
        let currentControl = control;
        errPath.split('.').forEach(errPathChunk =>
            {
                currentControl = currentControl.controls[errPathChunk];
            })
        
        const ngErrs = errors[errPath].reduce((carry, current) =>
        {
            carry[current] = true;
            return carry;
        }, {})
        
        currentControl.setErrors(ngErrs);
        currentControl.touched = true;

    })

    console.log(errors)
  }

}
